import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import CatalogoInstitucion from './catalogo-institucion';
import CatalogoInstitucionDeleteDialog from './catalogo-institucion-delete-dialog';
import CatalogoInstitucionDetail from './catalogo-institucion-detail';
import CatalogoInstitucionUpdate from './catalogo-institucion-update';

const CatalogoInstitucionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<CatalogoInstitucion />} />
    <Route path="new" element={<CatalogoInstitucionUpdate />} />
    <Route path=":id">
      <Route index element={<CatalogoInstitucionDetail />} />
      <Route path="edit" element={<CatalogoInstitucionUpdate />} />
      <Route path="delete" element={<CatalogoInstitucionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CatalogoInstitucionRoutes;
